module.exports = __webpack_public_path__ + "static/img/zzzcg-logo.6d1b453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/zzzcg-logo.png
// module id = Fw7R
// module chunks = 0